import api from './api';

const companyService = {
  getAll: async (type?: string) => {
    const response = await api.get('/companies', { params: { type } });
    return response.data;
  },

  getSuppliers: async () => {
    const response = await api.get('/companies/suppliers');
    return response.data;
  },

  getBuyers: async () => {
    const response = await api.get('/companies/buyers');
    return response.data;
  },

  getMyCompany: async () => {
    const response = await api.get('/companies/my-company');
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },

  create: async (data: any) => {
    const response = await api.post('/companies', data);
    return response.data;
  },

  update: async (id: string, data: any) => {
    const response = await api.put(`/companies/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/companies/${id}`);
    return response.data;
  },
};

export default companyService;